import { ActiveLeadState, LeadStatus } from '@bariendo/lib/active-lead';
import { MRT_ColumnDef, MRT_RowData } from 'mantine-react-table';
import { LeadStatusCell } from '@/components/LeadStatus/LeadStatusCell';
import { QUEUE_COLUMN_SIZE } from '../../components/QueueTable';

/** The lead's status, changeable from the row; `Undo n` while a Hold or Lost is pending. */

interface StatusRowLike extends MRT_RowData {
  patient?: { id?: string };
  activeLead?: ActiveLeadState;
  /** Seconds left on a pending Hold or Lost. */
  statusUndoSecondsLeft?: number;
}

export interface StatusColumnOptions {
  onChange: (patientId: string, status: LeadStatus) => void;
  onUndo: (patientId: string) => void;
  /** `Lead status` on a tab that also shows a payment status, so the two never share a name. */
  header?: string;
}

export function statusColumn<Row extends StatusRowLike>({
  onChange,
  onUndo,
  header = 'Status',
}: StatusColumnOptions): MRT_ColumnDef<Row> {
  return {
    id: 'status',
    header,
    size: QUEUE_COLUMN_SIZE.status,
    enableSorting: false,
    // Stays clear while the rest of a parked row fades.
    mantineTableBodyCellProps: { className: 'queue-cell-keep' },
    Cell: ({ row }) => {
      const patientId = row.original?.patient?.id;
      const lead = row.original?.activeLead;
      if (!patientId || !lead) {
        return null;
      }
      return (
        <LeadStatusCell
          status={lead.status}
          locked={lead.locked}
          lockedConsultStart={lead.lockedConsultStart}
          undoSecondsLeft={row.original.statusUndoSecondsLeft}
          onChange={(status) => onChange(patientId, status)}
          onUndo={() => onUndo(patientId)}
        />
      );
    },
  };
}
